/** @format */

import { axiosInstance } from '@common/application/context/Providers';

// Author search is backed by Microsoft Graph (User.Read.All); fields below reflect that source.
export class Author {
  id?: string;
  firstName: string;
  lastName: string;
  email: string;
  fullName?: string;
  jobTitle?: string;
  department?: string;
  phone?: string;

  static list(search: string, signal): Promise<{ payload: { data: Array<Author> } }> {
    if (typeof window !== 'undefined') {
      return axiosInstance.get(`/api/v1/author?search=${search}`, { signal }).then((res) => ({ ...res.data }));
    }
    throw new Error();
  }
}
